import Styles from './SimulationView.module.scss';
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { AuthContext } from 'components/lib';
import { useContext } from 'react';

//icons
import CircleIcon from '@mui/icons-material/Circle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


function SelectOptions({ displayValue, value, selected, onSelect }) {


    const handleSelect = () => {
        onSelect(value);
    };

    return (
        <div
            id='selectOptions_main'
            onClick={handleSelect}
            className={Styles.selectOptions_main}
        >
            <span>
                {selected ? <CheckCircleIcon fontSize='large' sx={{ color: "#fff" }} /> : <CircleIcon fontSize='large' sx={{ color: "#fff" }} />}
            </span>
            <p className={Styles.selectOptions_value}>{displayValue}</p>
        </div>
    )
}


export function SimulationView({ data, answers, setAnswers, onComplete, nextDisabled }) {

    const [selectedItem, setSelectedItem] = useState('');
    const [selectedReason, setSelectedReason] = useState();
    const [incorrect, setIncorrect] = useState([]);
    const [showExplanation, setShowExplanation] = useState();
    const authContext = useContext(AuthContext);
    const user_name =  `${authContext?.user?.first_name} ${authContext?.user?.last_name}`;
    const handleSelectItem = (item) => {
        setSelectedItem(item);
    };

    const handleSelectReason = (item) => {
        setSelectedReason(item);
    };

    const handleError = (message, type) => {
        toast.dark(message, {
            type: type,
            position: 'top-right',
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    const handleSubmit = () => {
        if (!selectedItem) {
            return handleError("Select at least one option", "error")
        }
        const ans = {
            name: data?.name,
            optionSelected: selectedItem,

        }
        setAnswers((previousAnswers) => {
            const existingIndex = previousAnswers.simulation.findIndex(
                (item) => item.name === ans.name
            );
            if (existingIndex !== -1) {
                return {
                    ...previousAnswers,
                    simulation: [
                        ...previousAnswers.simulation.slice(0, existingIndex),
                        ans,
                        ...previousAnswers.simulation.slice(existingIndex + 1),
                    ],
                };
            } else {
                return {
                    ...previousAnswers,
                    simulation: [...previousAnswers.simulation, ans],
                };
            }
        })
        if (selectedItem.isCorrect) {
            setShowExplanation('correct');
            nextDisabled();
        } else {
            setShowExplanation('incorrect')
        }
    }

    const handleCheck = (scene) => {
        if (incorrect.includes(scene)) {
            return;
        }

        setIncorrect([...incorrect, scene])
    }

    return (
        <div className={Styles.simulationView_ancestorContainer}>
            <ToastContainer
                id="warning-toast"
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            {!showExplanation &&
                <div className={Styles.main_container}>
                    <div className={Styles.title_options_container}>
                        <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${data?.icon}`} width="25%" alt='scenario icon' />
                        <p className={Styles.scenario_title}>{data?.title?.toUpperCase()}</p>
                        <p className={Styles.question}>What will you do?</p>
                        <div className={Styles.answerOptions}>
                            {data?.options?.map((option, index) => {
                                return (
                                    <SelectOptions
                                        key={`${option}-optionIndex-${index}`}
                                        displayValue={option?.value}
                                        value={option}
                                        selected={selectedItem?.value === option?.value}
                                        onSelect={handleSelectItem}
                                    />
                                )
                            })}
                        </div>
                        <button className={Styles.submitButton} onClick={handleSubmit}>
                            SUBMIT
                        </button>
                    </div>
                    <div className={Styles.scenario_container}>
                        {
                            data?.scenario &&
                            data?.scenario?.map((scene, index) => {
                                return (
                                    <p key={`${index}-scene`} className={Styles.scene}>
                                        {scene?.replace("<Name>", user_name)}
                                    </p>
                                )
                            })
                        }
                        {
                            data?.image &&
                            <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${data?.image}`} width='70%' alt='scenario' />
                        }
                    </div>
                </div>
            }
            {
                showExplanation === 'correct' &&
                <div className={Styles.correct_container}>
                    <div className={Styles.reason_options}>
                        <div className={Styles.headers_correct_view}>
                            <p className={Styles.congrats}>Congrats</p>
                            <p style={{ fontWeight: 600, color: 'black', fontSize: '0.8em' }}>YOU SAVED THE DAY</p>

                        </div>
                        <p style={{ color: 'black', fontSize: '0.8em' }}>What made you select "{selectedItem.value}"?</p>
                        <div className={Styles.reasonSelected}>
                            {
                                data?.option_reason?.map((reason, index) => {
                                    return (
                                        <SelectOptions
                                            key={`key-${reason}-${index}`}
                                            displayValue={reason}
                                            value={reason}
                                            selected={selectedReason === reason}
                                            onSelect={handleSelectReason}
                                        />
                                    )
                                })
                            }
                            <button onClick={onComplete} className={Styles.submitButton}>
                                SUBMIT
                            </button>
                        </div>

                    </div>
                    <div className={Styles.correctIcon}>
                        <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${data?.icon}`} width="45%" alt='scenario icon' />
                    </div>
                </div>
            }
            {
                showExplanation === 'incorrect' &&
                <div className={Styles.correct_container}>
                    <div className={Styles.reason_options} style={{ maxWidth: "40%", minWidth: "40%", display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', flexGrow: 1 }}>
                        <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${data?.incorrect_icon}`} style={{ marginBottom: '0.5em' }} alt="incorrect icon" width="18%" />
                        <p style={{ fontWeight: 600, color: 'black', fontSize: '1.1em', marginBottom: '0.5em' }}>YOU'VE JUST GOT '<span style={{ color: 'red' }}>{selectedItem?.type}</span>'</p>
                        <p style={{ alignSelf: 'flex-start', marginLeft: '0.2em', color: 'black' }}>Check the following</p>
                        <div className={Styles.reasonSelected} style={{ width: "100%", alignItems: 'flex-start' }}>
                            {
                                data?.incorrect_scenario?.map((scene, index) => {
                                    return (
                                        <label key={`${scene.scene}-index=${index}`} style={{ display: 'flex', gap: '0.7em' }}>
                                            <input
                                                className={Styles.checkBoxOptions}
                                                type="checkbox"
                                                checked={incorrect.includes(scene)}
                                                onChange={() => {
                                                    handleCheck(scene);
                                                }}
                                            />
                                            <p
                                                style={{
                                                    color: index % 2 === 0 ? "#148AA0" : "red",
                                                    fontWeight: 700
                                                }}
                                            >{scene.scene}</p>
                                        </label>
                                    )
                                })
                            }
                        </div>
                        <button onClick={() => { setShowExplanation() }} disabled={incorrect?.length !== data?.incorrect_scenario?.length} className={Styles.submitButton}>
                            Try Again
                        </button>
                    </div>
                    {
                        data?.incorrect_scenario_image ?
                            <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${data?.incorrect_scenario_image}`} width='45%' alt='scenario' />
                            :
                            <div className={Styles.correctIcon} style={{ flexDirection: 'column', fontSize: '0.75em', gap: '1em' }}>
                                {
                                    incorrect?.length > 0 &&
                                    incorrect?.map((scene, index) => {
                                        return (
                                            <p
                                                key={`${scene.scene}-${index}`}
                                                style={{
                                                    color: index % 2 === 0 ? "#148AA0" : "red",
                                                    fontWeight: 600
                                                }}
                                            >
                                                {scene?.descr}
                                            </p>
                                        )

                                    })
                                }
                            </div>}
                </div>
            }
        </div>
    )
}

//https://cdn.iconscout.com/icon/premium/png-512-thumb/omg-4448733-3690582.png?f=webp&w=256